/* Used by Storefront */
import React from "react";
import { Icon } from "@clarkinc/zest-design-system/ui";
import { BranchCategoryDetail } from "~/common/Store/models/Category";
import VisibleHiddenText from "../VisibleHiddenText";

const Resources = ({
  seoCategoryProperties,
  linkedResources,
}: BranchCategoryDetail) => {
  const title = seoCategoryProperties?.seoHeadline;

  let visibleMarkup = "";
  if (seoCategoryProperties?.visibleMarkup) {
    visibleMarkup = seoCategoryProperties.visibleMarkup;
  }
  if (seoCategoryProperties?.bottomDescription) {
    visibleMarkup =
      `${visibleMarkup} ${seoCategoryProperties.bottomDescription}`.trim();
  }

  const featuredLinkedResourced = linkedResources.filter((x) => x.isFeatured);

  const nonFeaturedLinkedResourced = linkedResources.filter(
    (x) => !x.isFeatured,
  );

  const renderedBottomHeader = (() => {
    if (seoCategoryProperties?.bottomHeader?.length) {
      return (
        <h3
          className="resources__title"
          dangerouslySetInnerHTML={{
            __html: seoCategoryProperties.bottomHeader,
          }}
        />
      );
    }

    return title && <h3 className="resources__title">{title}</h3>;
  })();

  return (
    <div className="resources resources--photo-grid">
      <div className="resources__text" style={{ marginTop: 0 }}>
        {renderedBottomHeader}
        <VisibleHiddenText
          visibleText={seoCategoryProperties?.seoVisibleText}
          visibleMarkup={visibleMarkup}
          overflowText={seoCategoryProperties?.overflowText}
          hideHiddenText
        />
      </div>
      <div className="resources__links">
        {featuredLinkedResourced.length > 0 && (
          <div className="resources__links-section">
            <div className="resources__links-title">Featured Resources:</div>
            {featuredLinkedResourced.map((x) => (
              <a
                href={x.link}
                className="resources__block"
                target="_blank"
                rel="noopener noreferrer"
                key={x.link}
              >
                <div
                  className="resources__img"
                  style={{ backgroundImage: `url(${x.image})` }}
                />
                <div className="resources__block-text">
                  <p className="resources__block-title max-h-full">
                    {x.description || x.title}
                  </p>
                  <p className="resources__block-link flex items-center">
                    {"Read More "}
                    <Icon
                      className="h-4 w-4 fill-current m-0"
                      name="ri-arrow-right-s-line"
                    />
                  </p>
                </div>
              </a>
            ))}
          </div>
        )}
        {nonFeaturedLinkedResourced.length > 0 && (
          <div className="resources__links-section">
            <div className="resources__links-title">Additional Resources:</div>
            <ul className="resources__list">
              {nonFeaturedLinkedResourced.map((linkedResource) => (
                <li key={linkedResource.link}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="resources__list-link"
                    href={linkedResource.link}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 icon"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                      />
                    </svg>
                    <p className="ml-[29px] mb-0">{linkedResource.title}</p>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Resources;
